import { Component } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
    selector: 'lib-gung-settings-security-view',
    templateUrl: './gung-settings-security-view.component.html',
    styleUrl: './gung-settings-security-view.component.scss',
    standalone: false
})
export class GungSettingsSecurityViewComponent extends GungSettingsBaseViewComponent {}
